import { render } from "./bookBalance.vue?vue&type=template&id=56fac307&scoped=true"
import script from "./bookBalance.vue?vue&type=script&lang=js"
export * from "./bookBalance.vue?vue&type=script&lang=js"

import "./bookBalance.vue?vue&type=style&index=0&id=56fac307&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fac307"]])

export default __exports__